import React, { FC, ComponentProps } from "react";
import { cls } from "cls";
const Name: FC<ComponentProps<"span">> = ({
  className,
  children,
  ...rest
}) => <span data-testid="topper-item-title" className={cls(className, "topper-item-title font-semibold leading-4 mb-0 pb-px text-[#257400]", "group-hover:text-green-800 group-hover:underline", "group-active:text-green-800 group-active:underline")} style={{
  overflow: "hidden",
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: 3
}} {...rest} data-sentry-component="Name" data-sentry-source-file="index.tsx">
    {children}
  </span>;
export default Name;